"use client"

import { blogSlug } from "components/Blog/utils/Blog.utils"
import { LandingPageProvider } from "packages/acquisition/components/chakra-components/LandingPage/LandingPageProvider"
import React from "react"
import type { ReducedBlogV2ArticleType } from "types/blog-v2-types"
import { siteUrl } from "utils/getSiteUrl"
import { PostBreadcrumb } from "../../components/Post/PostBreadcrumb"
import { PostContent } from "../../components/Post/PostContent"
import { PostHeader } from "../../components/Post/PostHeader"
import { PostHeroImage } from "../../components/Post/PostHeroImage"
import { PostRelatedContent } from "../../components/Post/PostRelatedContent"
import { PostShare } from "../../components/Post/PostShare"
import { PostTags } from "../../components/Post/PostTags"
import { useSegment } from "tracking"
import type { VariantType } from "types"

type Props = {
  article: ReducedBlogV2ArticleType
  locale: "en-GB" | "en-US"
  relatedContent: ReducedBlogV2ArticleType[]
  preview?: boolean
  variants?: VariantType[]
}

import { container } from "./Post.css"
import { FeaturedProductsQuickShop } from "packages/acquisition/components/chakra-components/CMS/FeaturedProducts/FeaturedProductsQuickShop"
import type { GeneralVariant } from "types/cms"
import { PreviewNotification } from "packages/ui-shared/components/PreviewNotification"

export const PostPage: React.FC<Props> = ({
  article,
  preview,
  locale,
  relatedContent,
  variants,
}) => {
  const {
    id,
    slug,
    tags,
    title,
    author,
    publishDate,
    heroImage,
    content,
    wideTemplate,
  } = article
  const pageSlug = `${siteUrl}${
    locale === "en-US" ? "/us" : ""
  }${blogSlug}/${slug}`

  const { track } = useSegment()

  const trackingModule = {
    modulePosition: 2,
    moduleContent: "",
    moduleId: `blogPost-${article.id}`,
    pageId: article.id,
    track,
  }
  return (
    <LandingPageProvider pageId={id} variants={variants ?? []}>
      <div className={container}>
        {preview && <PreviewNotification slug={pageSlug} locale={locale} />}
        <PostBreadcrumb
          tag={tags[0]}
          slug={slug}
          title={title}
          locale={locale}
        />
        <PostHeader
          title={title}
          author={author}
          publishDate={publishDate}
          locale={locale}
        />
        <PostShare title={title} slug={pageSlug} image={heroImage} />
        <PostHeroImage image={heroImage} />
        <PostContent content={content} wideTemplate={wideTemplate} />
        <PostTags tags={tags} locale={locale} />
        {variants && variants.length >= 2 && (
          <FeaturedProductsQuickShop
            trackingModule={trackingModule}
            variants={variants as unknown as GeneralVariant[]}
            title="Shop the Edit"
            gridTemplateColumns={[
              "repeat(1, 1fr)",
              "repeat(1, 1fr)",
              "repeat(3, 1fr)",
            ]}
          />
        )}
        <PostRelatedContent relatedContent={relatedContent} locale={locale} />
      </div>
    </LandingPageProvider>
  )
}
